import { render, staticRenderFns } from "./ExploreTokensLastPriceUpdated.vue?vue&type=template&id=febaa22e&scoped=true"
import script from "./ExploreTokensLastPriceUpdated.vue?vue&type=script&lang=ts"
export * from "./ExploreTokensLastPriceUpdated.vue?vue&type=script&lang=ts"
import style0 from "./ExploreTokensLastPriceUpdated.vue?vue&type=style&index=0&id=febaa22e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "febaa22e",
  null
  
)

export default component.exports